<template>
  <div class="n-icon-edit-suite">
    <FormOutlined v-if="cStatus === STATUS.NORMAL" class="n-icon-edit" @click="onBtnEdit()" />
    <span v-else class="space-x-2">
      <LoadingOutlined v-if="cLoading" class="n-icon-loading" />
      <CheckOutlined v-else class="n-icon-confirm" @click="onBtnConfirm()" />
      <CloseOutlined class="n-icon-cancel" @click="onBtnCancel()" />
    </span>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';

const props = defineProps({
  onConfirm: { type: Function, default: () => {} },
  onCancel: { type: Function, default: () => {} },
  onEdit: { type: Function, default: () => {} },
  status: String,
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['update:status', 'update:loading']);

const STATUS = {
  NORMAL: 'normal',
  EDIT: 'editing',
};

const innerStatus = ref(props.status || STATUS.NORMAL);
const innerLoading = ref(props.loading);
const cStatus = computed(() => (hasStatusProp.value ? props.status : innerStatus.value));
const cLoading = computed(() => innerLoading.value && props.loading);

const hasStatusProp = computed(() => props.status !== undefined);

function onBtnEdit() {
  const promisifyFunc = async () => props.onEdit();
  return promisifyFunc().then(() => {
    setStatus(STATUS.EDIT);
  });
}

function setStatus(value) {
  innerStatus.value = value;
  emit('update:status', value);
}

function setLoading(value) {
  innerLoading.value = value;
  emit('update:loading', value);
}

function onBtnConfirm() {
  setLoading(true);

  const promisifyFunc = async () => props.onConfirm();
  return promisifyFunc()
    .then((close = true) => {
      close && setStatus(STATUS.NORMAL);
    })
    .finally(() => {
      setLoading(false);
    });
}

function onBtnCancel() {
  const promisifyFunc = async () => props.onCancel();
  return promisifyFunc()
    .then(() => {
      setStatus(STATUS.NORMAL);
    })
    .finally(() => {
      setLoading(false);
    });
}
</script>

<script>
export default {
  name: 'NIconEditSuite',
};
</script>

<style lang="less">
.n-icon-edit-suite {
  .c-icon-btn() {
    @apply cursor-pointer hover:scale-125;
  }

  .n-icon-edit {
    color: @error-color;
    .c-icon-btn();
  }

  .n-icon-loading {
    @apply text-gray-500;
  }

  .n-icon-confirm {
    color: @success-color;
    .c-icon-btn();
  }

  .n-icon-cancel {
    @apply text-gray-500;
    .c-icon-btn();
  }
}
</style>
